<template>
  <div id="logout-page">
    <v-row align="center" justify="center">
      <v-col align="center">
        <v-progress-circular :size="60" :width="4" color="primary" indeterminate></v-progress-circular>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "Logout",
  methods: {
    ...mapActions(["logout"])
  },
  created() {
    this.logout();
  }
};
</script>

<style lang="scss">
</style>
